import React, { useState } from "react";
import cn from "classnames";
import ButtonSwitch, { ButtonItem } from "../controls/ButtonSwitch";
import DigiAuthForm from "./DigiAuthForm";
import Header from "../boxes/Header"
import EmailPasswordForm from "./EmailPasswordForm";
import { AuthProvider, UserRole } from "../../types/user";
import { SignUpForm } from "./types";
import { t } from "../../i18n";
import { getURLParam } from "../../utils/url";

const getSwitchButtons = (userRole: UserRole, signIn: boolean | undefined):ButtonItem<AuthProvider>[] => {
  const buttonItemAuthEmail: ButtonItem<AuthProvider> = { id: "email", i18nKey: "registration.auth_mode.email" };
  const switchButtons: ButtonItem<AuthProvider>[] = [
    { id: "idcard", i18nKey: "registration.auth_mode.id_card", icon: "flag-ee" },
    { id: "smartid", i18nKey: "registration.auth_mode.smartid", icon: "flag-ee" },
    { id: "mobileid", i18nKey: "registration.auth_mode.mobileid", icon: "flag-ee" },
  ];

  if (userRole === "business_borrower" || userRole === "investor" || signIn) {
    switchButtons.push(buttonItemAuthEmail);
  }

  return switchButtons;
};

const FormComponents: Record<AuthProvider, SignUpForm | null> = {
  email: EmailPasswordForm,
  idcard: DigiAuthForm,
  mobileid: DigiAuthForm,
  smartid: DigiAuthForm,
}

interface Props {
  headerI18nKey?: string;
  signIn?: boolean
  userRole: UserRole
  withAutoFocus?: boolean;
}

const NewUserForm = ({ headerI18nKey, signIn, userRole, withAutoFocus = true }: Props): JSX.Element => {
  const [authProvider, setAuthProvider] = useState<AuthProvider>("idcard");
  if (!headerI18nKey) headerI18nKey = signIn ? "sign_in" : "create_account";
  let authSubheaderI18nKey = "auth_subheader";
  const isUserExists = getURLParam("type") === "user_exists";
  const FormComponent = FormComponents[authProvider];
  if (userRole === "borrower" || userRole === "business_borrower") {
    authSubheaderI18nKey = "auth_subheader_borrower";
  }
  if (isUserExists) {
    headerI18nKey = "sign_in_user_exists";
    authSubheaderI18nKey = "auth_subheader_user_exists";
  }

  return (
    <div className ={cn({ "flex flex-col items-center": isUserExists })}>
      <Header
        className={cn({ "max-w-lg text-3xl font-extrabold text-center": isUserExists })}
        i18nKey={`registration.${headerI18nKey}`}
      />
      <p className="max-w-xl mt-5 md:mt-10">{t(`registration.${authSubheaderI18nKey}`)}</p>
      <div className={cn({ "w-80": isUserExists })}>
        <ButtonSwitch
          activeId={authProvider}
          buttons={getSwitchButtons(userRole, signIn)}
          className="max-w-sm mt-5"
          onChange={setAuthProvider}
        />
        {FormComponent && (
          <FormComponent
            isUserExists={isUserExists}
            provider={authProvider}
            signIn={signIn}
            userRole={userRole}
            withAutoFocus={withAutoFocus}
          />
        )}
      </div>
    </div>
  )
}

export default NewUserForm
